(function () {
  var ATTRIBUTE_NAMES = {
    country: 'DPD Country',
    pickup_id: 'DPD Pickup ID',
    pickup_type: 'DPD Pickup Type',
    pickup_name: 'DPD Pickup Name',
    pickup_address: 'DPD Pickup Address',
    pickup_city: 'DPD Pickup City',
    pickup_postcode: 'DPD Pickup Postcode'
  };

  var CONFLICTING_ATTRIBUTE_NAMES = [
    'BOX NOW Locker ID',
    'BOX NOW Locker Name',
    'BOX NOW Locker Address',
    'BOX NOW Locker Postal Code',
    'Speedy Country',
    'Speedy Pickup ID',
    'Speedy Pickup PUDO ID',
    'Speedy Pickup Type',
    'Speedy Pickup Name',
    'Speedy Pickup Address',
    'Speedy Pickup City',
    'Speedy Pickup Postcode'
  ];

  var EMPTY_VALUES = {
    country: '',
    pickup_id: '',
    pickup_type: '',
    pickup_name: '',
    pickup_address: '',
    pickup_city: '',
    pickup_postcode: ''
  };

  var DEFAULT_MESSAGES = {
    defaultName: 'Selected DPD pickup point',
    saving: 'Saving DPD pickup point...',
    saved: 'DPD pickup point saved.',
    saveMissing: 'Shopify did not return the pickup point on the cart. Please try again.',
    saveFailed: 'Shopify could not save the DPD pickup point. Please try again.',
    waitSaving: 'Please wait while your DPD pickup point is saved.',
    required: 'Please choose a DPD pickup point before checkout.',
    missingId: 'This pickup point did not return an ID. Choose another point.'
  };

  function getRoot() {
    return document.querySelector('[data-dpd-pickup]');
  }

  function getCartRoot() {
    return window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  }

  function toDatasetMessageKey(key) {
    return 'dpdMessage' + key.charAt(0).toUpperCase() + key.slice(1);
  }

  function getMessage(root, key) {
    return (root.dataset && root.dataset[toDatasetMessageKey(key)]) || DEFAULT_MESSAGES[key] || '';
  }

  function setMessage(root, message, type) {
    var status = root.querySelector('[data-dpd-status]');
    var error = root.querySelector('[data-dpd-error]');

    if (status) {
      status.textContent = type === 'success' || type === 'loading' ? message : '';
      status.hidden = !(type === 'success' || type === 'loading');
    }

    if (error) {
      error.textContent = type === 'error' ? message : '';
      error.hidden = type !== 'error';
    }
  }

  function setFields(root, values) {
    Object.keys(ATTRIBUTE_NAMES).forEach(function (key) {
      var field = root.querySelector('[data-dpd-field="' + key + '"]');

      if (field) {
        field.value = values[key] || '';
      }
    });
  }

  function getPickupIdentifier(root) {
    var id = root.querySelector('[data-dpd-field="pickup_id"]');
    return id && id.value ? id.value : '';
  }

  function firstValue() {
    for (var index = 0; index < arguments.length; index += 1) {
      var value = arguments[index];

      if (value !== undefined && value !== null && value !== '' && typeof value !== 'object') {
        return value;
      }
    }

    return '';
  }

  function nestedValue(object, path) {
    var value = object;

    path.split('.').forEach(function (part) {
      value = value && typeof value === 'object' ? value[part] : undefined;
    });

    return value;
  }

  function fieldFromAddress(address, key) {
    if (!address || typeof address !== 'object') {
      return '';
    }

    return firstValue(
      address[key],
      address[key && key.toLowerCase ? key.toLowerCase() : key],
      address[key && key.toUpperCase ? key.toUpperCase() : key]
    );
  }

  function formatAddressObject(address) {
    if (!address || typeof address !== 'object') {
      return '';
    }

    return firstValue(
      address.fullAddress,
      address.fullAddressString,
      address.addressLine,
      address.addressLine1,
      address.address,
      [
        firstValue(address.streetType, address.street_type),
        firstValue(address.streetName, address.street),
        firstValue(address.streetNo, address.number, address.no),
        firstValue(address.blockNo, address.block),
        firstValue(address.entranceNo, address.entrance),
        firstValue(address.floorNo, address.floor),
        firstValue(address.apartmentNo, address.apartment)
      ].filter(Boolean).join(' ')
    );
  }

  function normalizeOffice(payload, country) {
    if (typeof payload === 'string') {
      try {
        payload = JSON.parse(payload);
      } catch (error) {
        // Keep plain string payloads as office IDs.
      }
    }

    var office = payload && payload.office ? payload.office : payload;
    var address = office && office.address ? office.address : {};

    if (typeof office === 'string' || typeof office === 'number') {
      return {
        country: country,
        pickup_id: String(office),
        pickup_type: '',
        pickup_name: '',
        pickup_address: '',
        pickup_city: '',
        pickup_postcode: ''
      };
    }

    office = office || {};

    var id = firstValue(
      office.id,
      office.officeId,
      office.officeID,
      office.office_id,
      office.officeNo,
      office.officeNum,
      office.officeNumber,
      office.pickupId
    );

    var name = firstValue(
      office.name,
      office.officeName,
      office.office_name,
      office.label,
      office.title
    );

    var city = firstValue(
      office.city,
      office.siteName,
      office.site,
      office.locality,
      nestedValue(office, 'site.name'),
      fieldFromAddress(address, 'city'),
      fieldFromAddress(address, 'siteName')
    );

    var addressLine = firstValue(
      office.fullAddress,
      office.addressFull,
      office.addressText,
      office.street,
      nestedValue(office, 'address.fullAddress'),
      nestedValue(office, 'address.fullAddressString'),
      nestedValue(office, 'address.addressLine'),
      nestedValue(office, 'address.addressLine1'),
      fieldFromAddress(address, 'fullAddress'),
      fieldFromAddress(address, 'address'),
      fieldFromAddress(address, 'street'),
      formatAddressObject(address)
    );

    var postcode = firstValue(
      office.postCode,
      office.postcode,
      office.post_code,
      office.postalCode,
      fieldFromAddress(address, 'postCode'),
      fieldFromAddress(address, 'postalCode')
    );

    return {
      country: country,
      pickup_id: String(id || ''),
      pickup_type: String(firstValue(office.type, office.officeType, office.kind) || ''),
      pickup_name: String(name || ''),
      pickup_address: String(addressLine || ''),
      pickup_city: String(city || ''),
      pickup_postcode: String(postcode || '')
    };
  }

  function renderSelection(root, values) {
    var selectedBox = root.querySelector('[data-dpd-selected]');
    var selectedName = root.querySelector('[data-dpd-selected-name]');
    var selectedAddress = root.querySelector('[data-dpd-selected-address]');

    if (selectedName) {
      selectedName.textContent = values.pickup_name || (values.pickup_id ? getMessage(root, 'defaultName') + ' #' + values.pickup_id : getMessage(root, 'defaultName'));
    }

    if (selectedAddress) {
      selectedAddress.textContent = [
        values.pickup_city,
        values.pickup_address,
        values.pickup_postcode
      ].filter(Boolean).join(', ');
    }

    if (selectedBox) {
      selectedBox.hidden = !values.pickup_id;
    }
  }

  function buildCartData(values) {
    var formData = new FormData();

    Object.keys(ATTRIBUTE_NAMES).forEach(function (key) {
      formData.append('attributes[' + ATTRIBUTE_NAMES[key] + ']', values[key] || '');
    });

    CONFLICTING_ATTRIBUTE_NAMES.forEach(function (name) {
      formData.append('attributes[' + name + ']', '');
    });

    return formData;
  }

  function saveToCart(values) {
    return fetch(getCartRoot() + 'cart/update.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: buildCartData(values)
    }).then(function (response) {
      return response.json().then(function (cart) {
        if (!response.ok) {
          var error = new Error('Shopify cart update failed');
          error.cart = cart;
          throw error;
        }

        return cart;
      });
    });
  }

  function saveOffice(root, payload) {
    var values = normalizeOffice(payload, root.dataset.dpdCountry || 'RO');

    if (!values.pickup_id) {
      window.DpdPickupLastIgnoredMessage = payload;
      setMessage(root, getMessage(root, 'missingId'), 'error');
      return Promise.resolve(false);
    }

    root.dataset.dpdSaving = 'true';
    root.dataset.dpdSaved = 'false';
    setFields(root, values);
    renderSelection(root, values);
    setMessage(root, getMessage(root, 'saving'), 'loading');

    return saveToCart(values)
      .then(function (cart) {
        var saved = cart.attributes && cart.attributes[ATTRIBUTE_NAMES.pickup_id];

        window.DpdPickupLastSave = {
          attributes: values,
          cartAttributes: cart.attributes,
          rawSelection: payload,
          saved: Boolean(saved)
        };

        root.dataset.dpdSaving = 'false';
        root.dataset.dpdSaved = saved ? 'true' : 'false';
        setMessage(root, saved ? getMessage(root, 'saved') : getMessage(root, 'saveMissing'), saved ? 'success' : 'error');
        return Boolean(saved);
      })
      .catch(function (error) {
        window.DpdPickupLastError = error;
        root.dataset.dpdSaving = 'false';
        root.dataset.dpdSaved = 'false';
        setFields(root, EMPTY_VALUES);
        renderSelection(root, EMPTY_VALUES);
        setMessage(root, getMessage(root, 'saveFailed'), 'error');
        return false;
      });
  }

  function isAllowedWidgetOrigin(root, origin) {
    var allowedOrigin = root.dataset.dpdWidgetOrigin || 'https://services.dpd.ro';
    return origin === allowedOrigin;
  }

  function handleWidgetMessage(event) {
    var root = getRoot();

    if (!root || !isAllowedWidgetOrigin(root, event.origin)) {
      return;
    }

    if (event.data === undefined || event.data === null || event.data === '') {
      return;
    }

    saveOffice(root, event.data);
  }

  function blockCheckout(event) {
    var root = getRoot();
    var checkout = event.target.closest && event.target.closest('button[name="checkout"], input[name="checkout"]');

    if (!root || !checkout || root.dataset.dpdRequired !== 'true') {
      return;
    }

    if (root.dataset.dpdSaving === 'true') {
      setMessage(root, getMessage(root, 'waitSaving'), 'error');
      root.scrollIntoView({ behavior: 'smooth', block: 'center' });
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    if (getPickupIdentifier(root) && root.dataset.dpdSaved === 'true') {
      return;
    }

    setMessage(root, getMessage(root, 'required'), 'error');
    root.scrollIntoView({ behavior: 'smooth', block: 'center' });
    event.preventDefault();
    event.stopPropagation();
  }

  function init() {
    var root = getRoot();

    if (!root || root.dataset.dpdInitialized === 'true') {
      return;
    }

    root.dataset.dpdInitialized = 'true';
    root.dataset.dpdSaving = 'false';
    root.dataset.dpdSaved = getPickupIdentifier(root) ? 'true' : 'false';

    window.addEventListener('message', handleWidgetMessage, false);
    document.addEventListener('click', blockCheckout, true);
  }

  window.DpdPickup = {
    save: function (payload) {
      var root = getRoot();
      return root ? saveOffice(root, payload) : Promise.resolve(false);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
